export default "__VITE_ASSET__naShTqbS__"